import { axiosGet } from "@/services/axiosService";
import { useQuery } from "@tanstack/react-query";

export default function useGetCompany() {
  return useQuery({
    queryKey: ["getCompany"],
    queryFn: async () => {
      const res = await axiosGet("users/getCompany");
      return res;
    },
  });
}
